import {SxProps, Theme} from '@mui/material';

export const confirmBodySx: SxProps<Theme> = {
    padding: '20px 24px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

export const confirmActionsSx: SxProps<Theme> = (theme: Theme) => ({
    padding: theme.spacing(20 / 8, 24 / 8),
    borderTop: `1px solid ${theme.palette.neutral[200]}`,
    background: theme.palette.neutral[50],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(20 / 8),
});

// The app's control size - the theme's own button padding would make it 50px tall.
export const confirmButtonSx: SxProps<Theme> = {
    height: '36px',
    padding: '0 14px',
    borderRadius: '8px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
};
